module.exports = __webpack_public_path__ + "img/Msc.bd4b6082.jpeg";